import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// firebase init - add your own config here
const firebaseConfig = {
    apiKey: process.env.FIREBASE.apiKey,
    authDomain: process.env.FIREBASE.authDomain,
    databaseURL: process.env.FIREBASE.databaseURL,
    projectId: process.env.FIREBASE.projectId,
    storageBucket: process.env.FIREBASE.storageBucket,
    messagingSenderId: process.env.FIREBASE.messagingSenderId,
    appId: process.env.FIREBASE.appId,
    measurementId: process.env.FIREBASE.measurementId
}

firebase.initializeApp(firebaseConfig)

export default ({ Vue }) => {
    Vue.prototype.$firebase = firebase;

}
